type Option = { value: string; disabled?: boolean };

/** Ordinary parameters share a presentation; historical selections always need a picker. */
export const getGameParameterPresentation = (
  options: Option[],
  selected: string[],
  presentation: 'picker' | 'auto' = 'picker'
) => {
  if (presentation !== 'auto') return 'picker';
  if (!options.some((option) => !option.disabled) && selected.length === 0) return 'empty';
  if (
    options.length <= 4 &&
    !options.some((option) => option.disabled) &&
    selected.every((value) => options.some((option) => option.value === value))
  )
    return 'pill';
  return 'picker';
};
